import { Stack } from "@mui/material";
import ThresholdsTable from "../tables/ThresholdsTable";
import ThresholdConfigurationFilter from "../filters/ThresholdsConfigurationFilter";

function ThresholdConfiguration() {
    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <ThresholdConfigurationFilter/>
            <ThresholdsTable/>
        </Stack>
    )
}

export default ThresholdConfiguration;